"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const hopper_types_1 = require("./hopper.types");
const initialState = {
    isSuccess: false,
    isLoading: true,
    isError: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    summaryMode: 'today',
    dataItem: {
        id: '',
        main_entrance_in: new Date(),
        gate_in: new Date(),
        gate_out: new Date(),
        lead_time: '',
        ticket_no: '',
        hauler_no: '',
        dumping_hopper: '',
        vessel1_no: '',
        vessel2_no: '',
        brand_name: '',
        queue_time: '',
        driver_name: '',
        total_volume: 0,
        dumping_type: '',
        total_capacity: 0,
        checkpoint_name: '',
        contractor_name: '',
        capacity_volume1: 0,
        capicity_volume2: 0,
        transaction_type: '',
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'ticket_no', dir: 'desc' }],
    },
};
const dailySummaryHopperReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [hopper_types_1.dailySummaryHopperTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [hopper_types_1.dailySummaryHopperTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [hopper_types_1.dailySummaryHopperTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [hopper_types_1.dailySummaryHopperTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [hopper_types_1.dailySummaryHopperTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, isError,
            errorCode,
            errorMessage, isSuccess: false });
    },
    [hopper_types_1.dailySummaryHopperTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    },
    [hopper_types_1.dailySummaryHopperTypes.ON_SUMMARY_MODE_CLICK]: (state, action) => {
        return Object.assign(Object.assign({}, state), { summaryMode: action.payload.summaryMode, isLoading: true });
    },
});
exports.default = dailySummaryHopperReducer;
